import { makeVerseImage } from "./verseImage";
import { APP_NAME, APP_PLAY_URL } from "./appLinks";

// Share a verse — preferring a beautiful image (verse over artwork) via the
// device's native share sheet, then plain text, then clipboard. The Google
// Play link to the app is always embedded in the shared text.
export async function shareVerse({ bookName, chapter, verse, text, translation, withImage = true }) {
  const ref = `${bookName} ${chapter}:${verse}`;
  const body = `\u201C${text}\u201D\n\u2014 ${ref}${translation ? ` (${translation})` : ""}\n\nRead the Bible free on ${APP_NAME}:\n${APP_PLAY_URL}`;

  // 1) image share (richest, great for social / messaging)
  if (withImage && typeof navigator !== "undefined" && navigator.canShare) {
    try {
      const blob = await makeVerseImage({ text, reference: ref, translation });
      if (blob) {
        const file = new File([blob], `${bookName}-${chapter}-${verse}.png`, { type: "image/png" });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], text: body, title: ref });
          return "shared";
        }
      }
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
      // fall through to text share
    }
  }

  // 2) plain text share
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: ref, text: body });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
    }
  }

  // 3) clipboard fallback
  try {
    await navigator.clipboard.writeText(body);
    return "copied";
  } catch {
    return "failed";
  }
}
